const { createReducer } = require("@reduxjs/toolkit");
const { SET_LOCATION_FOR_DEALER_SUGGESTIONS } = require("actions/types");

const initialState = {
  activeLocationMessage: null,
};

const dealerLocationSuggestionReducer = createReducer(initialState, {
  [SET_LOCATION_FOR_DEALER_SUGGESTIONS]: (state, action) => {
    state.activeLocationMessage = action.payload;
  },
});

export default dealerLocationSuggestionReducer;
